import { AlertsHistorical } from '../../../../../shared/types/legalProceedings/alerts';

export interface AlertHistoricalProps {
    historical: AlertsHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createdAt: 'Fecha de creación',
    status: 'Estado',
    receptionChannel: 'Canal de recepción',
    typePQR: 'Tipo PQR',
    receivedThrough: 'Medio',
    subtypeDP: 'Subtipo DP',
    transaction: 'Tramite',
    motive: 'Motivo',
    nameAlert: 'Nombre',
    ruleNumber: 'Nº de regla',
    active: 'Activo',
    newPqrStatus: 'Nuevo Estado PQR',
    observation: 'Observación',
    alertDate: 'Fecha',
    classification: 'Clasificación',
    numberDays: 'Número de días',
    alertByMail: 'Alerta por correo',
    emailOfficials: 'Direcciones de correo electrónico',
    tags: 'Tags',
    subject: 'Asunto',
    template: 'Template',
};
